import gsap from 'gsap';

import { Elements } from './Elements';
import { FetchData } from './FetchData';
export class CloneModal {
  elements: Elements = new Elements();
  modal: HTMLElement | null;
  enableMicButton: HTMLElement | null;
  modalVideo: HTMLVideoElement | null;
  modalText: HTMLElement | null;
  chatArea: HTMLElement | null;
  externalDataArray: any;

  isOpen: boolean;
  introVideoDuration: number;

  openTimeline: gsap.core.Timeline | null = null; // Add this line to store the timeline

  constructor(_data?: any) {
    if (_data) {
      this.externalDataArray = _data.data;
    }
    this.isOpen = false;
    this.modal = this.elements.get('modal') as HTMLElement | null;

    this.modalVideo = this.elements.get('modalVideo') as HTMLVideoElement | null;
    this.introVideoDuration = 0.12;
    this.enableMicButton = this.elements.get('enableMic') as HTMLElement | null;

    // hide this
    if (this.enableMicButton) {
      // this.enableMicButton.style.display = 'none';
      gsap.set(this.enableMicButton, { autoAlpha: 0 });
    }

    this.modalText = this.elements.get('modalText') as HTMLElement | null;
    this.chatArea = this.elements.get('chatArea') as HTMLElement | null;
    if (!this.modal) {
      return;
    }
    this.initializeModal();
  }

  private initializeModal(): void {
    gsap.set(this.modal, {
      autoAlpha: 0,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9999,
    });
  }

  public init(): void {
    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    const openModalElements = this.elements.getAll('openModal');
    const closeModalElements = this.elements.getAll('closeModal');
    const enableMicElements = this.elements.getAll('micButton');

    openModalElements.forEach((button) => {
      button.addEventListener('click', this.handleOpenModalClick.bind(this));
    });
    enableMicElements.forEach((button) => {
      button.addEventListener('click', this.handleMicButtonClick.bind(this));
    });

    closeModalElements.forEach((button) => {
      button.addEventListener('click', this.handleCloseModalClick.bind(this));
    });
  }

  private handleOpenModalClick(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    if (this.externalDataArray) {
      this.populateModalDataExternal(e);
    } else {
      this.populateModalData(e);
    }
    this.open();
  }
  private handleMicButtonClick(e: Event): void {
    e.preventDefault();
    //this.openMic();
  }
  private handleCloseModalClick(e: Event): void {
    e.preventDefault();
    this.close();
  }
  private populateModalDataExternal(e: Event): void {
    const target = e.target as Element;

    const parentWithData = target.closest('[cc-element="component-wrapper"]');

    //console.log('parentWithData', parentWithData);

    const modalContent = parentWithData?.querySelector(
      '[data-modal="container"]'
    ) as Element | null;
    //console.log('modalContent', modalContent);
    const videoURL = modalContent?.getAttribute('data-modal-video');
    const influencerID = parentWithData?.getAttribute('data-influencer-id');
    const chatIframeWrapper = this.modal?.querySelector('.chat-box_content');
    const targetId = Number(influencerID);
    const item = this.externalDataArray.find((item: { id: number }) => item.id === targetId);
    if (modalContent) {
      const modalHeader = modalContent.querySelector('[data-modal="heading"]');
      const modalParagraph = modalContent.querySelector('[data-modal="paragraph"]');
      const modalSpecialty = modalContent.querySelector('[data-modal="specialty"]');
      if (modalHeader) {
        modalHeader.textContent = item.attributes.name;
      }
      if (modalParagraph) {
        modalParagraph.textContent = '';
      }
      if (modalSpecialty) {
        modalSpecialty.textContent = item.attributes.byline;
      }
      this.setModalContent('modalHeader', modalContent, '[data-modal="heading"]');
      this.setModalContent('modalParagraph', modalContent, '[data-modal="paragraph"]');
      this.setModalContent('modalSpecialty', modalContent, '[data-modal="specialty"]');
    }
    //chat-box_content
    if (this.modalVideo && videoURL) {
      const sourceElement = this.modalVideo.querySelector('source');
      if (sourceElement) {
        sourceElement.src = videoURL;
        this.modalVideo.load();
        this.modalVideo.addEventListener('loadedmetadata', () => {
          this.introVideoDuration = this.modalVideo?.duration ?? 0;
          //  console.log('Video duration:', videoDuration);
        });
      }
    }
    if (influencerID)
      FetchData.fetchInfluencerChat(influencerID, influencerID)
        .then((data) => {
          // Extract the desired data
          const { instanceHandle } = data.data.attributes;
          const { iframeUrl } = data.data.attributes;
          const { createdAt } = data.data.attributes;
          const { updatedAt } = data.data.attributes;
          const { type } = data.data.attributes;

          // Now you have the data in variables. You can use these in your class or pass them to other methods.

          if (chatIframeWrapper) {
            this.embedIframe(chatIframeWrapper, iframeUrl);
          }
        })
        .catch((error) => {
          console.error('Error while creating chat:', error);
        });
  }
  private populateModalData(e: Event): void {
    const target = e.target as Element;

    const parentWithData = target.closest('[cc-element="component-wrapper"]');

    const modalContent = parentWithData?.querySelector(
      '[data-modal="container"]'
    ) as Element | null;
    const videoURL = modalContent?.getAttribute('data-modal-video');

    this.setModalContent('modalHeader', modalContent, '[data-modal="heading"]');
    this.setModalContent('modalParagraph', modalContent, '[data-modal="paragraph"]');
    this.setModalContent('modalSpecialty', modalContent, '[data-modal="specialty"]');
    this.setModalContent('modalCtaButton', modalContent, '[data-modal="button"]');
    this.setModalContent('modalCtaButtonMobile', modalContent, '[data-modal="button"]');
    //modal-cta-button-mobile

    if (this.modalVideo && videoURL) {
      const sourceElement = this.modalVideo.querySelector('source');
      if (sourceElement) {
        sourceElement.src = videoURL;
        this.modalVideo.load();
        this.modalVideo.addEventListener('loadedmetadata', () => {
          this.introVideoDuration = this.modalVideo?.duration ?? 0;
          //  console.log('Video duration:', videoDuration);
        });
      }
    }
  }

  private setModalContent(elementKey: string, modalContent: Element | null, query: string): void {
    const element = this.elements.get(elementKey);

    const textContent = modalContent?.querySelector(query)?.textContent;

    const href = modalContent?.querySelector('a')?.href;

    if (href && href !== undefined) {
      const link = element as HTMLLinkElement;

      if (link && link !== undefined) {
        link.href = href;
      }
    }

    if (element && textContent !== undefined) {
      element.textContent = textContent;
    }
  }
  // public openMic(): void {
  //   gsap.to(this.modalText, { display: 'none' });
  //   gsap.set(this.enableMicButton, { autoAlpha: 0 });

  //   gsap.set(this.chatArea, { display: 'block' });
  //   this.chatAreaOpen();
  // }
  public open(): void {
    if (this.modal) {
      // gsap.set(this.enableMicButton, { autoAlpha: 0 });
      gsap.set(this.chatArea, { display: 'none' });
      gsap.to(this.modalText, { opacity: 1, display: 'block' });

      this.openTimeline = this.createOpenTimeline();
      document.body.style.overflow = 'hidden';
    }
  }
  private chatAreaOpen(): void {
    const myText = document.querySelector('#myText');
    const textToWrite = myText?.textContent;
    const messageBodyStr = textToWrite ?? '';
    if (myText) {
      myText.textContent = '';
    }

    const speed = 20;
    const endFlashSpeed = 0.3;
    const character = '|';

    const typingTl = gsap.timeline();

    typingTl
      .to(
        '#myText',
        {
          duration: messageBodyStr.length / speed,
          text: { value: messageBodyStr, newClass: 'typing' },
          ease: 'none',
          onUpdate: function () {
            const myText = document.querySelector('#myText');
            if (myText) {
              myText.textContent += character;
            }
          },
          onComplete: function () {
            const myText = document.querySelector('#myText');
            if (myText) {
              myText.textContent = messageBodyStr;
            }
          },
        },
        '+=0.5'
      )
      //makes it flash at the end
      .to('#myText', {
        duration: endFlashSpeed,
        text: { value: messageBodyStr + character, newClass: 'typing' },
        repeat: -1,
        repeatDelay: endFlashSpeed,
        ease: 'none',
      });
  }

  private createOpenTimeline(): gsap.core.Timeline {
    const tl = gsap.timeline({
      onComplete: () => {
        this.modalVideo?.play();

        gsap.to(this.enableMicButton, {
          autoAlpha: 1,
          duration: 0.3,
          delay: this.introVideoDuration,
          onStart: () => {
            const mm = gsap.matchMedia();
            mm.add('(max-width: 799px)', () => {
              gsap.to(this.modalText, { opacity: 0, display: 'none' }); // <- normal selector text, automatically scoped to myRefOrElement
            });
          },
        });
      },
    });

    tl.to(this.modal, { autoAlpha: 1, duration: 0.5, ease: 'power4.out' });
    tl.from(
      this.elements.get('modalWrapper'),
      {
        scale: 1.1, // Starting position (50 pixels above their original position)
        opacity: 0, // Starting from an opacity of 0 (invisible)

        duration: 0.5, // Duration of each icon's animation
        ease: 'power4.out', // Easing function for a smoother animation
      },
      0.1
    );

    tl.from(
      this.elements.get('modalHeader'),
      {
        yPercent: -10, // Starting position (50 pixels above their original position)
        opacity: 0, // Starting from an opacity of 0 (invisible)

        duration: 0.5, // Duration of each icon's animation
        ease: 'power4.out', // Easing function for a smoother animation
      },
      0.1
    );
    tl.from(
      this.elements.get('modalSpecialty'),
      {
        yPercent: -10, // Starting position (50 pixels above their original position)
        opacity: 0, // Starting from an opacity of 0 (invisible)

        duration: 0.5, // Duration of each icon's animation
        ease: 'power4.out', // Easing function for a smoother animation
      },
      0.2
    );
    tl.from(
      this.elements.get('modalParagraph'),
      {
        yPercent: -10, // Starting position (50 pixels above their original position)
        opacity: 0, // Starting from an opacity of 0 (invisible)

        duration: 0.5, // Duration of each icon's animation
        ease: 'power4.out', // Easing function for a smoother animation
      },
      0.3
    );

    tl.from(this.modalVideo, { autoAlpha: 0, duration: 0.5, ease: 'power4.out' }, 0.4);
    const icons = document.querySelectorAll('.icon-container .icon-link_link');

    // Animate them with GSAP
    tl.from(
      icons,
      {
        yPercent: -10, // Starting position (50 pixels above their original position)
        opacity: 0, // Starting from an opacity of 0 (invisible)
        stagger: 0.1, // 0.2 seconds delay between each icon's animation start
        duration: 0.5, // Duration of each icon's animation
        ease: 'power4.out', // Easing function for a smoother animation
      },
      0.6
    );

    return tl;
  }
  private findNearestSiblingWithAttribute(element: Element, attributeName: string): Element | null {
    // Start from the parent of the element
    let sibling = element.parentElement?.nextElementSibling;

    while (sibling) {
      if (sibling.hasAttribute(attributeName)) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }

    return null; // No sibling with the given attribute found
  }

  public close(): void {
    if (this.modal) {
      gsap.to(this.modal, { autoAlpha: 0 });
      gsap.killTweensOf(this.enableMicButton);
      document.body.style.overflow = '';
      this.modalVideo?.pause();

      gsap.set(this.enableMicButton, { autoAlpha: 0 });
    }
  }
  private embedIframe(chatIframeWrapper: Element, url: string): void {
    chatIframeWrapper.innerHTML = '';
    chatIframeWrapper.innerHTML = `<iframe src="${url}" width="100%" height="100%" frameborder="0" allow="microphone; camera"></iframe>`;
    // Logic to embed the iframe using the provided URL
  }
}
